export default "__VITE_ASSET__DSp3sHa5__"